import { getAllIpa, IpaType } from "../../phonemes/ipa";
import { IpaChartProps } from "./IpaChart";

export interface IpaProps {
  /** the associated IPA symbol */
  readonly s: IpaType;
  readonly p: IpaChartProps;
}

/** an IPA symbol that can change what's displayed & respond to clicks */
export function Ipa(props: IpaProps) {
  function over() {
    if (props.p.hovered) {
      props.p.hovered(props.s);
    }
  }
  function clicked() {
    if (props.p.clicked) {
      props.p.clicked(props.s);
    }
  }
  const canClick = props.p.canClick ? props.p.canClick(props.s) : (props.p.clicked !== undefined);
  const className = canClick ? 'pointer' : 'nopointer';
  const style = props.p.background ? { backgroundColor: props.p.background(props.s) } : undefined;
  return (
    <span className={className} style={style} onClick={() => clicked()} onMouseOver={() => over()}>
      {props.p.lookup(props.s)}
    </span>
  );
}

export interface IpaRowProps {
  readonly title?: string;
  /** e.g., [['p', 'b'], ['t', d']] or ['a', 'b', 'c'] */
  readonly symbols: IpaType[][] | IpaType[];
  readonly chartProps: IpaChartProps;
}

/** a table row of IPA pairs or singletons */
export function IpaRow(props: IpaRowProps) {
  const p = props.chartProps;
  return (<tr>
    {props.title ? <th>{props.title}</th> : undefined}
    {props.symbols.map((item, i) => {
      if (Array.isArray(item)) {
        if (item.length !== 2) {
          return <td key={i}></td>;
        }
        const s1 = item[0] === '' ? '•' : item[0];
        const s2 = item[1] === '' ? '•' : item[1];
        const br = props.chartProps.br ? <br /> : ' ';
        return <td key={i}><Ipa p={p} s={s1} />{br}<Ipa p={p} s={s2} /></td>
      } else {
        return <td key={i}><Ipa p={p} s={item} /></td>
      }
    })}
  </tr>);
}

export interface IpaVowelRowProps {
  readonly title: string;
  /** e.g., 'i y    ɨ ʉ   ɯ u' */
  readonly symbols: string;
  readonly chartProps: IpaChartProps;
}

/** a table row of spaced out IPA vowels */
export function IpaVowelRow(props: IpaVowelRowProps) {
  const p = props.chartProps;
  const chars = toArray(props.symbols);
  return (<tr>
    <th>{props.title}</th>
    <td>
      {chars.map((item, i) => {
        return item === ' ' ? <span key={i}>&nbsp;</span> : <Ipa s={item} p={p} key={i} />;
      })}
    </td>
  </tr>);
}

function toArray(s: string): string[] {
  const { diacritics } = getAllIpa();
  const r: string[] = [];
  for (let i = 0; i < s.length; i++) {
    const c = s.charAt(i);
    if (diacritics.includes(c)) {
      r[r.length - 1] += c; // add diacritic to previous symbol
    } else {
      r.push(c);
    }
  }
  return r;
}